import MicroModal from 'micromodal';

const handleFormSubmit = async (event, url, successCallback, errorCallback) => {
  event.preventDefault();

  const form = event.currentTarget;
  const formData = new FormData(form);

  try {
    const responseData = await postFormDataAsJson({ url, formData });
    const { status, bc_id, msg, tkn, nick } = responseData;

    if (status === 1) {
      // Determine the body content based on hub_support
      const bodyContent = window.hub_support
        ? { bc_id, token: tkn, uid: bc_id, nick }
        : { 
            login_name: formData.get('login_name'), 
            password: formData.get('password'), 
            token: tkn 
          };
    
      const fetchOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(bodyContent), // Properly stringified body
      };
    
      fetch(window.URL_login, fetchOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 1) {
            successCallback();
    
            if (window.ftb_timeout > 0) {
              if (window.app_id == 9) {
                document.querySelector('#login_btn').className = 'btn active';
              }
    
              window.ftb();
              setTimeout(() => {
                window.location.href = window.URL_route;
              }, window.ftb_timeout);
            } else {
              window.location.href = window.URL_route;
            }
          } else {
            errorCallback(data.msg);
          }
        })
        .catch((err) => {
          console.error('Fetch error:', err);
          errorCallback('An unexpected error occurred.');
        });
    } else {
      errorCallback(msg);
    }
  } catch (error) {
    console.log(error.message);
    errorCallback('');
  }
};

const handleLoginFormSubmit = (event) => {
    document.querySelector('#login_btn').innerHTML = 'Logging in...';

    const url = `${(hub_support) ? window.HUB_URL+'users/authgam3' : './users/login'}`;
    const successCallback = () => {
        document.querySelector('#login_btn').innerHTML = window.login_text;
    };
    
    const errorCallback = (msg) => {
        document.querySelector('#login_msg').style.display = 'block';
        document.querySelector('#login_msg').innerHTML = msg;
        document.querySelector('#login_btn').disabled = false;
        document.querySelector('#login_btn').innerHTML = 'Log In';
    };
    
    handleFormSubmit(event, url, successCallback, errorCallback);
};

const handleRegisterFormSubmit = (event) => {
    document.querySelector('#register_btn').innerHTML = window.registering_text;

    const url = `${(hub_support) ? window.TD_URL : './'}users/add`;
    const successCallback = () => {
        document.querySelector('#register_btn').innerHTML = window.installing_text;
    };
    
    const errorCallback = (msg) => {
        document.querySelector('#register_msg').style.display = 'block';
        document.querySelector('#register_msg').innerHTML = msg;
        document.querySelector('#register_btn').disabled = false;
        document.querySelector('#register_btn').innerHTML = window.register_button_label;
    };
    
    handleFormSubmit(event, url, successCallback, errorCallback);
};

const postFormDataAsJson = async ({ url, formData }) => {
  const plainFormData = Object.fromEntries(formData.entries());
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(plainFormData),
  };
  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }
  return response.json();
};

const trackScroll = () => {
  const scrolled = window.pageYOffset;
  const coords = document.documentElement.clientHeight / 2;
  const goTopBtn = document.querySelector('#back_to_top');
  if (scrolled > coords) {
    goTopBtn.classList.add('show');
  }
  if (scrolled < coords) {
    goTopBtn.classList.remove('show');
  }
};

const backToTop = () => {
    if (window.scrollY > 0) {
        window.scrollBy(0, -80);
        requestAnimationFrame(backToTop);
    }
};

const goTopBtn = document.querySelector('#back_to_top');
window.addEventListener('scroll', trackScroll);
if (goTopBtn) goTopBtn.addEventListener('click', backToTop);

const closeMobileNav = (e) => {
  document.querySelector('#mobile_nav input').checked = false;
};

const menuAnchors = document.querySelectorAll('#menu a li');
menuAnchors.forEach((anchor) => {
  anchor.addEventListener('click', closeMobileNav);
});

const smoothScrolling = (e) => {
  e.preventDefault();
  const target = document.querySelector(e.currentTarget.getAttribute('href'));
  target.scrollIntoView({ behavior: 'smooth' });

  closeMobileNav();
};

const anchorLinks = document.querySelectorAll('a[href^="#"]');
anchorLinks.forEach((anchor) => {
  anchor.addEventListener('click', smoothScrolling);
});

// fade screen to black after login/signup
window.ftb = function() {
    document.querySelector('.ftb').style.display = 'block';
    setTimeout(() => document.querySelector('.ftb').className = 'ftb active', 50);
}

const accordion = (event) => {
  const setClasses = !event.target.classList.contains('active');
  const acc = document.getElementsByClassName('accordion');
  const panel = document.getElementsByClassName('answer-panel');
  for (let i = 0; i < acc.length; i++) {
    acc[i].classList.remove('active');
    panel[i].classList.remove('show');
  }
  if (setClasses) {
    event.target.classList.toggle('active');
    event.target.nextElementSibling.classList.toggle('show');
  }
};

const faqPanels = document.querySelectorAll('.accordion');
faqPanels.forEach((panel) => {
  panel.addEventListener('click', accordion);
});

MicroModal.init({
  disableFocus: true,
  onShow: () => document.querySelector('#register_container [name="login_name"]').focus(),
//   onClose: (modal) => console.log(modal),
});

if (document.getElementById('login_form')) {
  const loginForm = document.getElementById('login_form');
  loginForm.addEventListener('submit', handleLoginFormSubmit);
}

if (document.getElementById('register_form')) {
  const registerForm = document.getElementById('register_form');
  registerForm.addEventListener('submit', handleRegisterFormSubmit);
}

// ======= SCREENSHOT MODAL =======
let current_index = 0;
const image_items = document.querySelectorAll('.image_item');

// Attach click event to each image and set data-index
image_items.forEach((image, index) => {
    image.setAttribute('data-index', index);
    image.addEventListener('click', function() {
        showModal(index);
    });
});

const modal = document.getElementById('screenshot_modal');
const modal_image = document.getElementById('modal_image');

function showModal(index) {
  current_index = index;
  modal_image.src = image_items[current_index].src;
  modal.style.display = 'block';
  // Wait for next paint cycle to actually show the modal with a transition
  setTimeout(() => { modal.classList.add('show'); }, 1);  
}

// screenshot modal
if (document.getElementsByClassName('screenshot_modal_close').length > 0) {
  document.getElementsByClassName('screenshot_modal_close')[0].onclick = function() {
    modal.classList.remove('show');
    // Wait for the transition to complete before setting display to 'none'
    setTimeout(() => { modal.style.display = 'none'; }, 300); 
  };

  document.getElementById('prev_button').onclick = function() {
      current_index = (current_index - 1 + image_items.length) % image_items.length;
      modal_image.src = image_items[current_index].src;
  };

  document.getElementById('next_button').onclick = function() {
      current_index = (current_index + 1) % image_items.length;
      modal_image.src = image_items[current_index].src;
  };
}

window.onclick = function(event) {
  if (event.target === modal) {
      modal.classList.remove('show');
      setTimeout(() => { modal.style.display = 'none'; }, 300);
  }
};